/*
  Variant availability fix
  ------------------------
  Bug: the theme's swatch picker marks a size (or other option value) as sold out
  based on whether ANY variant with that value is available anywhere in the product,
  rather than whether a variant is available for the COMBINATION currently selected
  (e.g. Metal + Finish + this Size together). This produces false 'sold out' crosses
  on sizes that are actually in stock for the selected Metal/Finish, and can also fail
  to correct itself when swatches are changed client-side.

  This script recomputes availability correctly per combination, using the product's
  own variant data (already embedded on the page via <script class="product-json">),
  and re-applies the correct available/soldout classes after any swatch selection
  changes. It only ever changes CSS classes for display; it never touches the
  underlying form/variant id, so Add to Cart behavior is unaffected.
*/
(function () {
  function init() {
    var jsonEl = document.querySelector('.product-json');
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.variants || !product.options) return;

    var optionCount = product.options.length;
    var swatchGroups = document.querySelectorAll('.swatch[data-option-index]');
    if (!swatchGroups.length) return;

    function getSelectedValues() {
      var selected = [];
      for (var i = 0; i < optionCount; i++) {
        var checked = document.querySelector('input[name="option-' + i + '"]:checked');
        selected[i] = checked ? checked.value : null;
      }
      return selected;
    }

    function combinationHasAvailableVariant(optionIndex, value, selected) {
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        if (!variant.available) continue;
        if (variant.options[optionIndex] !== value) continue;
        var matches = true;
        for (var i = 0; i < optionCount; i++) {
          if (i === optionIndex) continue;
          if (selected[i] && variant.options[i] !== selected[i]) {
            matches = false;
            break;
          }
        }
        if (matches) return true;
      }
      return false;
    }

    function recalc() {
      var selected = getSelectedValues();
      swatchGroups.forEach(function (group) {
        var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);
        var elements = group.querySelectorAll('.swatch-element[data-value]');
        elements.forEach(function (el) {
          var value = el.getAttribute('data-value');
          var isAvailable = combinationHasAvailableVariant(optionIndex, value, selected);
          el.classList.toggle('soldout', !isAvailable);
          el.classList.toggle('available', isAvailable);
        });
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input.wetheme-custom-radio')) {
        recalc();
        setTimeout(recalc, 50);
      }
    });

    recalc();
    setTimeout(recalc, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
